import React from "react";
import { SEGMENT_BZA, SEGMENT_BZA_ID, SEGMENT_CMC, SEGMENT_CMC_ID } from "../constants";
import SegmentedProductPage from "../SegmentedProductPage";
import CommercialOperatorContactData from "./CommercialOperatorContactData";
import BusinessOperatorContactData from "./BusinessOperatorContactData";
import { productPageProps } from "../../common/types/product";

export default function OperatorContactData({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<SegmentedProductPage
			tabsDefinition={[
				{
					id: SEGMENT_CMC_ID,
					title: `${SEGMENT_CMC} ${packageName}`,
					renderContent: (tabsNav) => (
						<CommercialOperatorContactData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
				{
					id: SEGMENT_BZA_ID,
					title: `${SEGMENT_BZA} ${packageName}`,
					renderContent: (tabsNav) => (
						<BusinessOperatorContactData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
			]}
		/>
	);
}
